import { useEffect } from "react";

// Tawk.to live chat — loaded ONLY on the marketing pages (Home, Signup/Sales).
//
// Behavior:
// - On mount, lazy-loads the Tawk.to embed script (idempotent — safe across
//   multiple mounts during in-app navigation).
// - When the script is ready, calls Tawk_API.showWidget() so re-visits show
//   the bubble again.
// - On unmount (e.g. visitor navigates to /s/<slug>/book), calls
//   Tawk_API.hideWidget() so the chat bubble disappears on app pages.
//
// Why hide instead of remove?  Tawk.to injects multiple iframes and listeners
// when loaded; removing them is unreliable.  hideWidget() is the official API
// and is instant.  The script is only fetched once per page load.
//
// Tawk.to property: 695dcdd0a482f1197c123ec0 / widget 1jeb6nug5
const TAWK_SRC = "https://embed.tawk.to/695dcdd0a482f1197c123ec0/1jeb6nug5";

let _scriptInjected = false;

function injectTawkScript() {
  if (_scriptInjected) return;
  _scriptInjected = true;

  // Initialize the Tawk_API global BEFORE the remote script loads (per Tawk docs).
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  const s = document.createElement("script");
  s.async = true;
  s.src = TAWK_SRC;
  s.charset = "UTF-8";
  // "anonymous" is the only HTML-spec-valid crossorigin value.  The default
  // Tawk snippet ships `crossorigin="*"` which Chrome treats as no-cors and
  // blocks via ERR_BLOCKED_BY_ORB.
  s.setAttribute("crossorigin", "anonymous");
  document.head.appendChild(s);
}

export default function TawkChat() {
  useEffect(() => {
    injectTawkScript();

    // Show the widget on mount.  If the script is still loading, queue the
    // action via Tawk_API.onLoad which fires when ready.
    const show = () => {
      try { window.Tawk_API?.showWidget?.(); } catch {/* ignore */}
    };
    if (window.Tawk_API?.showWidget) {
      show();
    } else {
      window.Tawk_API = window.Tawk_API || {};
      const prevOnLoad = window.Tawk_API.onLoad;
      window.Tawk_API.onLoad = function () {
        try { prevOnLoad?.(); } catch {/* ignore */}
        show();
      };
    }

    // On unmount (route change away from marketing pages), hide the widget so
    // it does NOT appear on booking/ticket/TV/admin pages.
    return () => {
      try { window.Tawk_API?.hideWidget?.(); } catch {/* ignore */}
    };
  }, []);

  // Renders nothing — the widget is injected directly by Tawk.to into <body>.
  return null;
}
